import { __decorate, __param, __metadata } from 'tslib';
import { ActionPointInfo } from '../../decorators/param/action-point-info.js';
import { StopAction } from '../../decorators/param/stop-action.js';
import { Middleware } from '../../decorators/class/middleware.js';
import { UIConfigToggle } from './ui-config-toggle.js';
import { ScopeToggle } from './scope-toggle.js';
import { ToggleService } from './action-toggle-service.js';
import { ControllerToggle } from './controller-toggle.js';

/**
 * 开关中间件, shouldHide为true, shouldDisable的为true, 其余方法均被禁用
 */
let ToggleMiddleware = class ToggleMiddleware {
    constructor(uiConfigToggle, scopeToggle, controllerToggle) {
        this.uiConfigToggle = uiConfigToggle;
        this.scopeToggle = scopeToggle;
        this.controllerToggle = controllerToggle;
    }
    use(info, stop) {
        // controller是否被禁用
        const toggleService = new ToggleService(info);
        toggleService.registerToggle(this.uiConfigToggle);
        toggleService.registerToggle(this.scopeToggle);
        toggleService.registerToggle(this.controllerToggle);
        const { isOn } = toggleService;
        if (!isOn) {
            stop();
            if (info.trigger === 'shouldHide' || info.trigger === 'shouldDisabled')
                return true;
        }
        return undefined;
    }
};
__decorate([
    __param(0, ActionPointInfo()),
    __param(1, StopAction()),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Function]),
    __metadata("design:returntype", void 0)
], ToggleMiddleware.prototype, "use", null);
ToggleMiddleware = __decorate([
    Middleware(),
    __metadata("design:paramtypes", [UIConfigToggle,
        ScopeToggle,
        ControllerToggle])
], ToggleMiddleware);

export { ToggleMiddleware };
//# sourceMappingURL=toggle-middleware.js.map
